import React from 'react';
import { Link } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';

const ForkliftNavBar = ({ activeLane, onLaneChange }) => {
  // All Lanes for Forklift
  const lanes = ['ALL'];

  const handleLane = lane => {
    onLaneChange(lane);
  };

  return (
    <div className="lane-list-container">
      <ListGroup vertical className="lane-list">
        {lanes.map(lane => (
          <ListGroup.Item
            key={lane}
            action
            onClick={() => handleLane(lane)}
            className={`lane-item ${lane === activeLane ? 'active' : ''}`}
          >
            <Link to="#" className="lane-link">
              {lane}
            </Link>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default ForkliftNavBar;
